(function() {

  /* ─────────────────────────────────────────
     SCROLL REVEAL
     rootMargin triggers slightly before element
     enters viewport so animation is already
     running when it comes into view.
  ───────────────────────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e, i) {
        if (e.isIntersecting) {
          setTimeout(function() { e.target.classList.add('visible'); }, i * 80);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -50px 0px' });
    reveals.forEach(function(r) { io.observe(r); });
  }

  /* ─────────────────────────────────────────
     HEADER SCROLL STYLING
     Passive listener — never blocks scroll thread.
     Single definition here; header.liquid inline
     script only handles --header-height.
  ───────────────────────────────────────────── */
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ─────────────────────────────────────────
     MAGNETIC BUTTONS
  ───────────────────────────────────────────── */
  document.querySelectorAll('.btn-primary, .magnetic').forEach(function(btn) {
    btn.addEventListener('mousemove', function(e) {
      var rect = btn.getBoundingClientRect();
      var x = (e.clientX - rect.left - rect.width / 2) * 0.25;
      var y = (e.clientY - rect.top - rect.height / 2) * 0.25;
      btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.transform = '';
    });
  });

  /* ─────────────────────────────────────────
     FULLSCREEN NAV OVERLAY
     aria-expanded toggled on all burger buttons.
     Open/close logic lives in nav-overlay.liquid
     to keep it co-located with the overlay markup.
  ───────────────────────────────────────────── */
  var navToggle = document.getElementById('navToggle');
  if (navToggle) {
    navToggle.setAttribute('aria-expanded', 'false');
    navToggle.addEventListener('click', function() {
      if (typeof window.openNavOverlay === 'function') window.openNavOverlay();
    });
  }

  /* ─────────────────────────────────────────
     PAGE TRANSITIONS
     Fixed: opacity is reset on pageshow so the
     browser back/forward cache (bfcache) restores
     correctly instead of showing a blank page.
     Keyboard modifier keys (Cmd/Ctrl/Shift) open
     in new tab as expected — transition skipped.
  ───────────────────────────────────────────── */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      /* Restored from bfcache — reset any lingering opacity */
      document.body.style.opacity = '';
      document.body.style.transition = '';
    }
  });

  document.querySelectorAll('a[href]').forEach(function(link) {
    if (link.hostname !== window.location.hostname) return;
    if (link.href.indexOf('#') !== -1) return;
    if (link.getAttribute('target') === '_blank') return;
    link.addEventListener('click', function(e) {
      /* Let Cmd/Ctrl/Shift clicks open normally */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var dest = link.href;
      document.body.style.opacity = '0';
      document.body.style.transition = 'opacity 0.3s ease';
      setTimeout(function() { window.location = dest; }, 320);
    });
  });

  /* ─────────────────────────────────────────
     CARD GALLERY — shared across collection and product pages
     galleryNext/galleryPrev called via onclick on arrow buttons.
     Defined here in theme.js so they're available on ALL page types
     (collection.liquid and product.liquid both use these).
  ───────────────────────────────────────────── */
  (function() {
    var _state = new WeakMap();

    function _getState(gallery) {
      if (!_state.has(gallery)) {
        _state.set(gallery, { slides: gallery.querySelectorAll('.card-slide'), current: 0 });
      }
      return _state.get(gallery);
    }

    function _goTo(gallery, idx) {
      var s = _getState(gallery);
      s.slides[s.current].classList.remove('active');
      s.current = (idx + s.slides.length) % s.slides.length;
      s.slides[s.current].classList.add('active');
    }

    window.galleryNext = function(btn) {
      var g = btn.closest('.card-gallery');
      if (g) { var s = _getState(g); _goTo(g, s.current + 1); }
    };
    window.galleryPrev = function(btn) {
      var g = btn.closest('.card-gallery');
      if (g) { var s = _getState(g); _goTo(g, s.current - 1); }
    };

    /* Touch swipe on all card galleries */
    function initGallerySwipe(gallery) {
      var slides = gallery.querySelectorAll('.card-slide');
      if (slides.length <= 1) return;
      _getState(gallery);
      var tx = 0, ty = 0;
      gallery.addEventListener('touchstart', function(e) {
        tx = e.touches[0].clientX; ty = e.touches[0].clientY;
      }, { passive: true });
      gallery.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - tx;
        var dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          var s = _getState(gallery);
          if (dx < 0) _goTo(gallery, s.current + 1);
          else        _goTo(gallery, s.current - 1);
        }
      }, { passive: true });
    }

    document.querySelectorAll('.card-gallery').forEach(initGallerySwipe);
  })();

  /* ─────────────────────────────────────────
     HERO CTA SCROLL
     Smooth-scrolls to #collections-section
     when the hero CTA button is clicked.
  ───────────────────────────────────────────── */
  document.querySelectorAll('.hero-cta-scroll').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var target = document.getElementById('collections-section');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ─────────────────────────────────────────
     HERO VIDEO MUTE TOGGLE
     Single canonical definition — removed from
     hero-video.liquid inline script to avoid
     duplicate / shadowing.
  ───────────────────────────────────────────── */
  window.toggleHeroMute = function() {
    var v   = document.getElementById('heroVideo');
    var lbl = document.getElementById('muteLbl');
    if (!v) return;
    v.muted = !v.muted;
    if (lbl) lbl.textContent = v.muted ? 'Sound On' : 'Sound Off';
  };

  /* ─────────────────────────────────────────
     LOOKBOOK MODAL
     Open/close logic is self-contained in
     sections/lookbook-video.liquid so it has
     direct access to the section-scoped element IDs.
     No global handlers needed here.
  ───────────────────────────────────────────── */

})();
